<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import axiosInstance from '@/plugins/axios'
import { OverviewTemplate } from '@/components'
import type { MenuItem } from '@/types'

interface TenantOverviewItem {
  _id: string
  name: string
  logoUrl?: string | null
}

const tenants = ref<TenantOverviewItem[]>([])
const menuItems = ref<MenuItem[]>([])
const assetBaseUrl = String(import.meta.env.VITE_ADMIN_ASSETS_URL ?? '')
const defaultTenantLogo = `${assetBaseUrl.replace(/\/$/, '')}/icons/tenant-icon.svg`

const getTenants = async () => {
  const res = await axiosInstance.get('/admin/getAllTenants')
  tenants.value = res.data
}

const resolveAssetUrl = (path: string) => {
  const normalizedBaseUrl = assetBaseUrl.replace(/\/$/, '')
  const normalizedPath = path.replace(/^\//, '')

  return `${normalizedBaseUrl}/${normalizedPath}`
}

const resolveTenantLogoUrl = (logoUrl?: string | null) => {
  if (!logoUrl) {
    return defaultTenantLogo
  }

  if (/^https?:\/\//i.test(logoUrl)) {
    return logoUrl
  }

  return resolveAssetUrl(logoUrl)
}

const mapTenantsToMenuItems = () => {
  return tenants.value.map((tenant) => ({
    label: tenant.name,
    to: `/admin/settings/tenants/${tenant._id}`,
    imageSrc: resolveTenantLogoUrl(tenant.logoUrl)
  }))
}

onMounted(async () => {
  await getTenants()
  menuItems.value = mapTenantsToMenuItems()
})
</script>

<template>
  <OverviewTemplate :getItemsFromRouter="false" :items="menuItems"> </OverviewTemplate>
</template>
